import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ROUTE_ANIMATIONS_ELEMENTS } from '../../../core/core.module';
import { entityDepositosLoadRequest } from '../../actividades/entity-depositos/depositos.actions';
import { entityGrupoEspecieLoadRequest } from '../../actividades/entity-grupos-especie/grupos-especie.actions';
import { entityLaboratoriosLoadRequest } from '../../actividades/entity-laboratorios/laboratorios.actions';
import { entityTipoAnalisisLaboratorioLoadRequest } from '../../actividades/entity-tipos-analisis-laboratorio/tipos-analisis-laboratorio.actions';
import { entityTiposDivisorMuestraLoadRequest } from '../../actividades/entity-tipos-divisor-muestra/tipos-divisor-muestra.actions';
import { entityTipoEquipamientoLaboratorioLoadRequest } from '../../actividades/entity-tipos-equipamiento-laboratorio/tipos-equipamiento-laboratorio.actions';
import { entityEntidadesProductivaLoadRequest } from '../../empresas/entity-entidad-productiva/entity-entidades-productiva.actions';
import { entityNaturalezaJuridicaLoadRequest } from '../../empresas/entity-naturalezas-juridica/entity-naturalezas-juridica.actions';
import { entityPersonasFisicaLoadRequest } from '../../empresas/entity-personas-fisica/entity-personas-fisica.actions';
import { entityPersonasJuridicaLoadRequest } from '../../empresas/entity-personas-juridica/entity-personas-juridica.actions';

import { Observable, Subscription } from 'rxjs';
import { entityEspecieLoadRequest } from '../../actividades/entity-especies/especies.actions';
import { entitySitiosProcesamientoLoadRequest } from '../../actividades/entity-sitios-procesamiento/sitios-procesamiento.actions';
import { entityTiposEquipamientoProcesamientoLoadRequest } from '../../actividades/entity-tipo-equipamiento-procesamiento/tipos-equipamiento-procesamiento.actions';
import { entityViverosGrupoEspecieLoadRequest } from '../../actividades/entity-viveros-grupo-especie/entity-viveros-grupo-especie.actions';
import { entitySexosLoadRequest } from '../../persona/entity-sexo/entity-sexo.actions';
import { entityTiposDocumentoLoadRequest } from '../../persona/entity-tipos-documento/entity-tipos-documento.actions';
import { entityTiposTecnicoLoadRequest } from '../../persona/entity-tipos-tecnico/entity-tipos-tecnico.actions';
import { entityRolLoadRequest } from '../../roles/entity-roles/entity-roles.actions';
import { entityTecnicoResponsableLoadRequest } from '../../roles/entity-tecnico-responsable/entity-tecnico-responsable.actions';
import { entityTecnicosLoadRequest } from '../../roles/entity-tecnicos/entity-tecnicos.actions';
import { entityTiposRolLoadRequest } from '../../roles/entity-tipos-rol/entity-tipos-rol.actions';
import { tramiteGetRequest } from '../../tramites/tramite.actions';
import { entityDepartamentosLoadRequest } from '../../ubicaciones/entity-departamentos/entity-departamentos.actions';
import { entityLocalidadesAllLoadRequest } from '../../ubicaciones/entity-localidades/entity-localidades.actions';
import { entityPaisesDocumentoLoadRequest } from '../../ubicaciones/entity-paises-documento/paises-documento.actions';
import { entityPaisesLoadRequest } from '../../ubicaciones/entity-paises/entity-paises.actions';
import { State } from '../../vista-usuario/vista-usuario.state';
import { items2IsLoading, selectIsLoadingItems } from '../principal.selectors';
import { entityMaquinaMovilLoadRequest } from '../../actividades/entity-maquinas-moviles/entity-maquinas-moviles.actions';
import { entityUserLoadRequest } from '../../persona/entity-usuarios/entity-usuarios.actions';
import { entityTiposSexoBiologicoLoadRequest } from '../../persona/entity-sexo-biologico/entity-sexo-biologico.actions';
import { tramiteStatusLoadRequest } from '../../tramites/tramite-status/tramite-status.actions';
import { entityEstadosRolLoadRequest } from '../../roles/entity-estado-rol/entity-estados-rol.actions';
import { entityEstadosLaboratorioLoadRequest } from '../../actividades/entity-estados-laboratorio/estados-laboratorio.actions';
import { movimientoTramiteLoadRequest } from '../../tramites/movimiento-tramite/movimiento-tramite.actions';
import { EntityEtapasEmpresaLoadRequest } from '../../empresas/entity-etapas-empresa/entity-etapas-empresa.actions';
import { EntityEspeciesCertificablesLoadRequest } from '../../actividades/entity-especies-certificables/entity-especies-certificables.actions';
import { EntityAcreditacionEmpresaLoadRequest } from '../../empresas/acreditacion-empresa/entity-acreditacion-empresa.actions';

@Component({
  selector: 'rpe-principal',
  templateUrl: './principal.component.html',
  styleUrls: ['./principal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrincipalComponent implements OnInit, OnDestroy {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  subscription: Subscription;
  isLoading$: Observable<boolean>;

  constructor(private store: Store<State>, private router: Router) { }

  ngOnInit(): void {
    // Usuario
    this.store.dispatch(entitySexosLoadRequest());
    this.store.dispatch(entityTiposSexoBiologicoLoadRequest);
    this.store.dispatch(entityUserLoadRequest());

    // Ubicacion
    this.store.dispatch(entityPaisesLoadRequest());
    this.store.dispatch(entityDepartamentosLoadRequest());
    this.store.dispatch(entityLocalidadesAllLoadRequest());

    // Documento
    this.store.dispatch(entityPaisesDocumentoLoadRequest());
    this.store.dispatch(entityTiposDocumentoLoadRequest());

    // Empresas
    this.store.dispatch(entityEntidadesProductivaLoadRequest());
    this.store.dispatch(entityPersonasFisicaLoadRequest());
    this.store.dispatch(entityPersonasJuridicaLoadRequest());
    this.store.dispatch(entityNaturalezaJuridicaLoadRequest());

    // Roles
    this.store.dispatch(entityRolLoadRequest());
    this.store.dispatch(entityTiposRolLoadRequest());
    this.store.dispatch(entityTecnicosLoadRequest());
    this.store.dispatch(entityTecnicoResponsableLoadRequest());
    this.store.dispatch(entityTiposTecnicoLoadRequest());
    this.store.dispatch(entityEstadosRolLoadRequest());

    // Tramites
    this.store.dispatch(tramiteGetRequest());
    this.store.dispatch(tramiteStatusLoadRequest());
    this.store.dispatch(movimientoTramiteLoadRequest());
    /*this.store.dispatch(entityRolesActividadLoadRequest());
    this.store.dispatch(entityMuestreadorLoadRequest());*/

    // Actividades
    /*this.store.dispatch(entityTiposActividadLoadRequest());
    this.store.dispatch(entityTiposSubActividadLoadRequest);
    this.store.dispatch(entityActividadesLoadRequest());
    this.store.dispatch(entityActividadesGrupoEspecieLoadRequest());*/
    this.store.dispatch(entityGrupoEspecieLoadRequest);
    this.store.dispatch(entityViverosGrupoEspecieLoadRequest());
    //this.store.dispatch(entityGruposEspecieTipoActividadLoadRequest);
    this.store.dispatch(entityDepositosLoadRequest());
    this.store.dispatch(entityTiposDivisorMuestraLoadRequest);
    this.store.dispatch(entityTipoAnalisisLaboratorioLoadRequest);
    this.store.dispatch(entityEstadosLaboratorioLoadRequest());
    this.store.dispatch(entityEspecieLoadRequest);
    this.store.dispatch(entityTipoEquipamientoLaboratorioLoadRequest());
    this.store.dispatch(entityMaquinaMovilLoadRequest());
    this.store.dispatch(entityTiposEquipamientoProcesamientoLoadRequest);
    //this.store.dispatch(entityTiposMovilidadLoadRequest);
    this.store.dispatch(entityLaboratoriosLoadRequest());
    this.store.dispatch(entitySitiosProcesamientoLoadRequest());
    //this.store.dispatch(entitySubActividadLoadRequest);
    //this.store.dispatch(entitySubActividadEspecieLoadRequest);
    //this.store.dispatch(entityComercializacionesLoadRequest());

    // Acreditacion
    //this.store.dispatch(EntityAcreditacionEmpresaLoadRequest())
    //this.store.dispatch(EntityEspeciesCertificablesLoadRequest())
    //this.store.dispatch(EntityEtapasEmpresaLoadRequest())

    this.isLoading$ = this.store.select(selectIsLoadingItems);
    this.subscription = this.isLoading$.subscribe((isLoading) => {
      if (!isLoading) {
        this.router.navigate(['main/landing']);
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
